import { ChordFlavour, getChordFlavours } from '../../const/chordFlavours';
import { InputContainer, Label } from '../../global/styles';
import Select from '../Select';

interface Props {
	value: string;
	onChange: (value: string) => void;
}

export default function FlavourSelect({ value, onChange }: Props) {
	// const hasExtraChords = useAppSelector(selectHasFeature(FeatureEnum.extrachords));
	const flavours: ChordFlavour[] = getChordFlavours(true);
	return (
		<InputContainer>
			<Label>Type:</Label>
			<Select
				options={Object.values(flavours).map(flavour => ({
					value: flavour?.id,
					label: flavour?.longName
				}))}
				value={value}
				onChange={onChange}
			/>
		</InputContainer>
	);
}
